/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from 'react';
import { Divider, Popover, Table, Whisper } from 'rsuite';
import PropTypes from 'prop-types';
import { Container, PaginationBar, StyledPagination } from './styles';
import './header.css';
import { DarkModeContext } from '../../common/contexts/darkMode';

export const TableHeaderLabel = ({ children }) => (
  <span
    className="table-header-label"
    title={typeof children === 'string' ? children : undefined} // bônus: tooltip nativo ao passar mouse
  >
    {children}
  </span>
);

TableHeaderLabel.propTypes = {
  children: PropTypes.node.isRequired,
};

export const TableHeaderTooltip = ({ label, tooltip }) => (
  <Whisper
    placement="bottom"
    trigger="hover"
    controlId="control-id-hover"
    speaker={
      <Popover>
        <p>{tooltip}</p>
      </Popover>
    }
  >
    <span className="table-header-label table-header-tooltip">
      {label}
    </span>
  </Whisper>
);

TableHeaderTooltip.propTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.string.isRequired,
};

export const TablePagination = ({
  wordWrap,
  dados,
  carregando,
  children,
  quantidade,
  onChangePage,
  setOrderBy,
  headerHeight,
  onRowClick,
  rowHeight,
  // rowClassName
}) => {
  const [page, setPage] = useState(1);
  const [sortType, setSortType] = useState();
  const [sortColumn, setSortColumn] = useState();
  const { toggleMode } = useContext(DarkModeContext)

  if (sortColumn && sortType) {
    setOrderBy(`order by ${sortColumn} desc`);
    if (sortType === 'desc') {
      setOrderBy(`order by ${sortColumn} asc`);
    }

  }

  function handleSortColumn(sortColumn1, sortType1) {
    setSortColumn(sortColumn1);
    setSortType(sortType1);
  }
  return (
    <Container darkMode={toggleMode}>
      <PaginationBar darkMode={toggleMode}>
        <span style={{ marginLeft: 20 }}>
          <Divider vertical />
          Total: {quantidade}
        </span>
        <StyledPagination
          prev
          next
          maxButtons={5}
          showLengthMenu={false}
          first
          last
          activePage={page}
          total={quantidade}
          onChangePage={(pagina) => {
            setPage(pagina);
            onChangePage(pagina);
          }}
        />
      </PaginationBar>
      <Table
        // rowClassName={rowClassName}
        onRowClick={onRowClick}
        loading={carregando}
        data={dados}
        sortType={sortType}
        sortColumn={sortColumn}
        // eslint-disable-next-line react/jsx-no-bind
        onSortColumn={handleSortColumn}
        // height={1420}
        autoHeight
        wordWrap={wordWrap}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        bordered={false}
        cellBordered={false}
      >
        {children}
      </Table>
      <PaginationBar darkMode={toggleMode}>
        <span style={{ marginLeft: 20 }}>
          <Divider vertical />
          Total: {quantidade}
        </span>
        <StyledPagination
          prev
          next
          maxButtons={5}
          showLengthMenu={false}
          first
          last
          activePage={page}
          total={quantidade}
          onChangePage={(pagina) => {
            setPage(pagina);
            onChangePage(pagina);
          }}
        />
      </PaginationBar>
    </Container >
  );
};

TablePagination.propTypes = {
  dados: PropTypes.array,
  carregando: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  quantidade: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChangePage: PropTypes.func.isRequired,
  setOrderBy: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  // rowClassName: PropTypes.func,
};

TablePagination.defaultProps = {
  dados: [],
  onRowClick: () => { },
  // rowClassName: () => { },
};
